export default {
  // 项目id
  project_id: 3
}
